import { createFileRoute, redirect } from "@tanstack/react-router";

import { isProjectTab, type ProjectTab } from "../components/projects/CmmdProjectTabs";
import { parseTaskSearchParam } from "../components/projects/taskSearchParam";

/**
 * Keeps saved links from the original project-board surface working. Points at
 * `/project/:id` directly rather than at `/cmmd/project/:id`, so a saved link
 * costs one redirect instead of chaining through a shim that is itself only a
 * redirect.
 *
 * This is also where CMMD's desktop handoff link lands
 * (`{FORGE_WEB_URL}/projects/{cmmdProjectId}?task={taskId}`).
 */
export const Route = createFileRoute("/_chat/projects/$cmmdProjectId")({
  validateSearch: (search: Record<string, unknown>): { task?: string; tab?: ProjectTab } => {
    const task = parseTaskSearchParam(search["task"]);
    const tab = search["tab"];
    return {
      ...(task !== undefined ? { task } : {}),
      ...(isProjectTab(tab) ? { tab } : {}),
    };
  },
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/project/$projectKey",
      params: { projectKey: params.cmmdProjectId },
      search,
      replace: true,
    });
  },
});
